export default __webpack_public_path__ + "img/7bb0cccd860733399d08ef7f85ddb70c.png";